import * as React from "react";
import { Button } from "@/components/ui/button";
import ConfirmExternalLink from "@/components/ConfirmExternalLink";
import { IndicadoresSelector } from "./IndicadoresSelector";
import type { Ferramenta } from "@/constants/ferramentas";

interface ToolCardProps {
  ferramenta: Ferramenta;
  index: number;
}

export const ToolCard = ({ ferramenta, index }: ToolCardProps) => {
  const [indicadoresOpen, setIndicadoresOpen] = React.useState(false);
  const IconComponent = ferramenta.icon;
  const isAvailable = ferramenta.status === "Disponível";
  const isExternal = 'externalUrl' in ferramenta;
  const isIndicadores = ferramenta.isIndicadores;

  return (
    <div
      className={`p-6 rounded-2xl bg-card border border-border hover:border-primary/50 transition-all hover:shadow-lg animate-slide-up stagger-${Math.min(index + 3, 6)} ${!isAvailable ? 'opacity-75' : ''}`}
    >
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-between mb-4">
          <div className="p-3 rounded-xl bg-primary/10">
            <IconComponent className="h-6 w-6 text-primary" />
          </div>
          <span className={`text-xs px-3 py-1 rounded-full ${isAvailable
            ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
            : 'bg-muted text-muted-foreground'
            }`}>
            {ferramenta.status}
          </span>
        </div>
        <h3 className="text-xl font-bold mb-2">{ferramenta.title}</h3>
        <p className="text-muted-foreground flex-1">{ferramenta.description}</p>
        {isIndicadores && isAvailable ? (
          <>
            <Button
              className="mt-4 w-full rounded-full bg-primary hover:bg-primary/90 text-primary-foreground"
              onClick={() => setIndicadoresOpen(true)}
            >
              Acessar
            </Button>
            <IndicadoresSelector open={indicadoresOpen} onOpenChange={setIndicadoresOpen} />
          </>
        ) : isExternal && isAvailable ? (
          <ConfirmExternalLink
            href={ferramenta.externalUrl!}
            title="Acessar ferramenta externa"
            description="Você será direcionado para uma ferramenta externa ao CIB. Deseja continuar?"
            confirmLabel="Acessar"
            className="mt-4 w-full"
          >
            <Button className="w-full rounded-full bg-primary hover:bg-primary/90 text-primary-foreground">
              Acessar
            </Button>
          </ConfirmExternalLink>
        ) : (
          <Button
            className={`mt-4 w-full rounded-full ${isAvailable
              ? 'bg-primary hover:bg-primary/90 text-primary-foreground'
              : 'bg-muted text-muted-foreground cursor-not-allowed'
              }`}
            disabled={!isAvailable}
          >
            {isAvailable ? 'Acessar' : 'Em breve'}
          </Button>
        )}
      </div>
    </div>
  );
};
